module.exports = __webpack_public_path__ + "static/media/how-it-works-4.c82db415.jpg";